// extracted by mini-css-extract-plugin
module.exports = {"childBlock":"style-module__childBlock___1vDGf"};